import { creator } from '@helpers/httpMethods'

interface PurchaseData {
  email: string
  currency: string
  items: {
    name: string
    price: number
  }[]
}

const trackLead = async (email: string) => {
  if (process.env.NEXT_PUBLIC_VERCEL_ENV == 'production') {
    try {
      await creator({
        url: '/api/hyros/leads',
        body: {
          email
        }
      })
    } catch {}
  } else {
    console.log('[hyros] Track Lead', { email })
  }
}

const trackPurchase = async ({ email, currency, items }: PurchaseData) => {
  if (process.env.NEXT_PUBLIC_VERCEL_ENV == 'production') {
    try {
      await creator({
        url: '/api/hyros/orders',
        body: {
          email,
          currency,
          items
        }
      })
    } catch {}
  } else {
    console.log('[hyros] Track Purchase', { email, currency, items })
  }
}

const hyr = { trackLead, trackPurchase }

export default hyr
